import { render } from "./ExtendReservation.vue?vue&type=template&id=184b06dd"
import script from "./ExtendReservation.vue?vue&type=script&lang=js"
export * from "./ExtendReservation.vue?vue&type=script&lang=js"

import "./ExtendReservation.vue?vue&type=style&index=0&id=184b06dd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__